import { render, staticRenderFns } from "./ErrorBlocked.vue?vue&type=template&id=3890a2c1&"
import script from "./ErrorBlocked.vue?vue&type=script&lang=js&"
export * from "./ErrorBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports